import { apiGet, apiPost, apiPut, apiDelete } from '../../../components/qv4/models/shared/apiClient';

function unwrap(response) {
  const body = response.data;
  if (!body?.success) throw Object.assign(new Error(body?.message || 'Teams and schedules request failed.'), { code: body?.code, data: body?.data });
  return body.data;
}
function failure(error) { const body = error.response?.data; return Object.assign(error, { code: body?.code || error.code, data: body?.data ?? error.data, status: error.response?.status || error.status }); }
export async function read(path, params = {}) {
  const query = new URLSearchParams(Object.entries(params).filter(([, value]) => value !== undefined && value !== null));
  try { return unwrap(await apiGet(`${path}${query.toString() ? `?${query}` : ''}`)); } catch (error) { throw failure(error); }
}
export const newKey = () => crypto.randomUUID();
// A request object is frozen once submitted; an uncertain result cannot silently
// change its body/key. Past confirmation adds only the documented flag.
export function frozenWrite(method, path, body, { key, version, dryRun = false } = {}) {
  const payload = JSON.parse(JSON.stringify({ ...body, ...(method === 'post' && !dryRun ? { idempotency_key: key } : {}), ...(version !== undefined ? { expected_version: version } : {}) }));
  let confirmed = false;
  return async function submit(affectsPast = false) {
    confirmed ||= affectsPast;
    const value = { ...payload, ...(confirmed ? { affects_past: true } : {}) };
    try { return unwrap(await ({ post: apiPost, put: apiPut, delete: apiDelete }[method])(path, value)); } catch (error) { throw failure(error); }
  };
}
export async function performWrite(request, { confirmPast, reload, notify }) {
  try {
    let result;
    try { result = await request(); }
    catch (error) {
      if (error.code !== 'ATTENDANCE_AFFECTS_PAST' || !await confirmPast(error.data)) throw error;
      result = await request(true);
    }
    await reload(); // Includes duplicate success and replacement IDs.
    return result;
  } catch (error) {
    if (['TEAM_VERSION_CONFLICT', 'ATTENDANCE_VERSION_CONFLICT'].includes(error.code)) { notify('Someone else changed this — reloaded'); await reload(); }
    throw error;
  }
}
